import React, {useEffect, useState} from "react";
import {Edit} from "@mui/icons-material";
import {Button, DialogActions, DialogContent} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {NODE_TYPE_DATAPORTAL} from "../../constants/nodes";
import Call from "../../hocs/call";
import CustomJsonForms from "../custom-json-forms";
import FullscreenDialog from "../fullscreen-dialog";
import {
  clearPackageManagerState,
  getPackage,
  getPackageSchema,
  updatePackage
} from "../../state/package-manager/packageManagerActions";
import {packageManagerSelector} from "../../state/package-manager/packageManagerSelectors";
import {userSelector} from "../../state/user/userSelectors";
import {canEditNode} from "../../utils/permissions";

const PackageEditButton = ({label, withIcon, nodeId, nodeType, packageId, callback}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const user = useSelector(userSelector);
  const {packageSchema, packageUiSchema, package: pkg} = useSelector(packageManagerSelector);

  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [errors, setErrors] = useState(null);
  const [showValidation, setShowValidation] = useState(false);

  const fetchPackageSchema = nodeId => {
    dispatch(getPackageSchema(nodeId));
  };

  const fetchPackage = ({nodeId, packageId}) => {
    dispatch(getPackage(nodeId, packageId));
  };

  const onEditPackageHide = () => {
    setIsOpen(false);
    dispatch(clearPackageManagerState());
  };

  const onEditPackageSubmit = () => {
    if ((errors || []).length > 0) {
      setShowValidation(true);
    } else {
      setShowValidation(false);
      dispatch(updatePackage(nodeId, packageId, data));
      dispatch(clearPackageManagerState());
      if (callback) callback();
    }
  };

  useEffect(() => {
    setData(pkg);
    setErrors(null);
    setShowValidation(false);

    return () => {
      setData(null);
      setErrors(null);
      setShowValidation(false);
    };
  }, [pkg]);

  return (
    canEditNode(user, nodeId) &&
    nodeType === NODE_TYPE_DATAPORTAL && (
      <>
        <Button startIcon={withIcon ? <Edit /> : null} onClick={() => setIsOpen(true)}>
          {label ? label : t("commons.confirm.edit")}
        </Button>
        <FullscreenDialog
          open={isOpen}
          title={t("modules.packageManager.packageSettings.editPackage.label")}
          onClose={onEditPackageHide}
          onSubmit={onEditPackageSubmit}
        >
          <DialogContent>
            <Call
              cb={fetchPackageSchema}
              cbParam={nodeId}
              disabled={!isOpen || Boolean(packageSchema && packageUiSchema)}
            >
              {packageSchema && packageUiSchema && (
                <Call cb={fetchPackage} cbParam={{nodeId: nodeId, packageId: packageId}} disabled={!packageId}>
                  <CustomJsonForms
                    schema={packageSchema}
                    uischema={packageUiSchema}
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    showValidation={showValidation}
                    i18nPrefix={"modules.packageManager.packageSettings"}
                  />
                </Call>
              )}
            </Call>
          </DialogContent>
          <DialogActions>
            <Button className="resource-settings__actions__cancel-btn" onClick={onEditPackageHide}>
              {t("commons.confirm.cancel")}
            </Button>
            <Button className="resource-settings__actions__submit-btn" onClick={onEditPackageSubmit} disabled={!data}>
              {t("commons.confirm.submit")}
            </Button>
          </DialogActions>
        </FullscreenDialog>
      </>
    )
  );
};

export default PackageEditButton;
